// This should match the flag defined in config/features.yml

export const CRS_IMPORT = 'crs_import';
